
var Sticky = require('./dist/sticky.compile.js');

module.exports = Sticky;



//////////////////
// WEBPACK FOOTER
// /var/www/arcadalabs.com/public_html/wp-content/themes/arcadalabs/node_modules/sticky-js/index.js
// module id = 8
// module chunks = 0